export default {
  common: {
    language: 'اللغة',
    logoAlt: 'Zhongze للتعليم والعلوم',
    cancel: 'إلغاء',
  },
  chatService: {
    chatNow: {
      label: 'تحدث الآن',
    },
    emailGate: {
      title: 'البريد الإلكتروني مطلوب',
      desc: 'يرجى إدخال بريدك الإلكتروني لمتابعة الدردشة.',
      successMessage: 'تم إرسال البريد الإلكتروني. يمكنك متابعة الدردشة.',
    },
  },
  nav: {
    home: 'الرئيسية',
    products: 'المنتجات',
    software: 'البرمجيات',
    eduServices: 'خدمات التعليم',
    support: 'الخدمة والدعم',
    cooperation: 'التعاون التعليمي',
    about: 'من نحن',

    // Sub-menus & Mega Menu
    learningPlatform: 'منصة Zhongze للتعلم',
    cloudPlatform: 'منصة Zhongze السحابية',
    laserSoftware: 'برمجيات مخصصة لأجهزة الليزر',
    makerK12: 'تعليم الصُنّاع - K12',
    archVocational: 'نماذج معمارية - التعليم المهني',
    cultHigherVoc: 'تصميم ثقافي وإبداعي - التعليم المهني العالي',
    artsUni: 'الفنون والحِرف - الجامعة',
    afterSales: 'خدمة ما بعد البيع',
    faq: 'الأسئلة الشائعة',
    download: 'مركز التنزيلات',
    companyIntro: 'نبذة عن الشركة',
    news: 'الأخبار',
    contact: 'اتصل بنا',
    device: 'الأجهزة',
    kits: 'الحِزم',
    softwareService: 'خدمات البرمجيات',
    accessories: 'الملحقات',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'نظام الحِزم',
    kitsAccessories: 'ملحقات الحِزم',
    courses: 'الدورات',
  },
  aboutPage: {
    seoTitle: 'من نحن - Zhongze للتعليم والعلوم',
    banner: {
      title: 'من نحن',
    },
    about: {
      title: 'من نحن',
      body: 'تأسست Zhongze للتعليم في عام 2015، وبفضل تعاوننا الوثيق مع Hong Kong Unicom International، قمنا بالاعتماد على مناهج STEAM الأوروبية والأمريكية لتطوير منظومة تعليم الصُنّاع المناسبة للأطفال. ومن خلال التعلم الاجتماعي والتطبيق العملي، نساعد الأطفال على تجاوز الحدود وصناعة إنجازات مبهرة. نضع “تعليم STEAM + مساحة الصُنّاع” في صميم عملنا، ونلتزم برسالة “تنمية صُنّاع المستقبل”، مع تركيزنا على تنمية الإبداع التكنولوجي للأطفال من 3 إلى 16 عاماً. ندير مساحات تعليم الابتكار العلمي والتقني، ونطور منتجات ودورات تعليمية ذاتياً. وبالتركيز على محاور مثل تعلم برمجيات التصميم ونقش الليزر والبرمجة، بنينا منظومة تطوير محتوى تعليمية مميزة وحلقة منتجات متكاملة. نُمكّن الأطفال من اكتساب كفاءات أساسية تلائم المستقبل عبر مشاريع حقيقية. رؤيتنا أن نكون مناصرين للتعليم الابتكاري على المستوى الدولي. نحن لا نقدم الدورات وبيئات الصُنّاع فحسب، بل نقدم أيضاً أسلوب تعلم جديداً كلياً. نؤمن بأن كل طفل هو مبتكر المستقبل—يفكر ويستكشف كالعالِم، ويطبق كالمهندس، ويبدع كالمصمم، ويتعلم التصنيع كالصانع—ليكتشف ذاته عبر الاستكشاف ويحقق مستقبله عبر الممارسة.',
    },
    intro: {
      title: 'لماذا تختارنا؟',
      desc: 'نسعى لأن نكون مناصرين للتعليم الابتكاري عالمياً، ونقدم الدورات وبيئات الصُنّاع، بل وأسلوب تعلم جديداً كلياً. نؤمن بأن كل طفل هو مبتكر المستقبل، ليكتشف ذاته عبر الاستكشاف ويحقق مستقبله عبر الممارسة.',
      features: {
        projectLearning:
          'التعلم القائم على المشاريع: عبر مشاريع واقعية، يكتسب الأطفال الكفاءات الأساسية اللازمة للمستقبل.',
        interactiveExperiments:
          'التجارب التفاعلية: تساعد هذه الأنشطة العملية الأطفال على إتقان المبادئ العلمية الأساسية وتطوير مهارات حل المشكلات والإبداع وروح العمل الجماعي.',
      },
    },
    images: {
      aboutAlt: 'حول Zhongze للتعليم والعلوم',
      featureIcon1Alt: 'أيقونة التعلم القائم على المشاريع',
      featureIcon2Alt: 'أيقونة التجارب التفاعلية',
      introAlt: 'لماذا تختارنا',
    },
  },
  newsPage: {
    banner: {
      title: 'الأخبار',
    },
    tabs: [
      { id: 'all', name: 'الكل' },
      { id: 'company', name: 'أخبار الشركة' },
      { id: 'exhibition', name: 'أخبار المعارض' },
      { id: 'industry', name: 'أخبار القطاع' },
    ],
    items: [
      {
        title:
          'تألقت Henghao Laser في BETT UK 2025: تمكين ابتكار التعليم بتقنيات الليزر',
      },
      {
        title: 'جوهر ابتكار تعليم K12: كيف يدفع قاطع الليزر CO2 تعليم STEAM',
      },
      {
        title:
          'عملاء Henghao Laser يتألقون مع Light 530 في didacta Italia 2025',
      },
      { title: 'Zhongze للتعليم والعلوم تطلق حلاً جديداً للتعليم الذكي' },
      {
        title:
          'اتجاهات التعليم المستقبلية: الاندماج العميق بين الذكاء الاصطناعي وتعليم الصُنّاع',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'الأخبار',
    },
    tabs: [
      { id: 'all', name: 'الكل' },
      { id: 'company', name: 'أخبار الشركة' },
      { id: 'exhibition', name: 'أخبار المعارض' },
      { id: 'industry', name: 'أخبار القطاع' },
    ],
    items: [
      {
        title:
          'Zhongze Technology تطلق حزمة روبوتات تعليمية من الجيل الجديد تقود موجة STEM الجديدة',
      },
      {
        title:
          'دخول الذكاء الاصطناعي إلى المدارس: كيف تعزز تعليم البرمجة التفكير المنطقي لدى الطلاب',
      },
      {
        title:
          'اختتام المسابقة الوطنية لروبوتات الشباب لعام 2023 بنجاح؛ فرق مدعومة من Zhongze تحقق نتائج مميزة',
      },
      {
        title:
          'استكشاف تعليم المستقبل: خطط بناء الفصول الذكية في ظل التحول الرقمي',
      },
      {
        title:
          'Zhongze Technology تعقد تعاوناً استراتيجياً مع عدة جامعات لإنشاء مختبر مشترك للذكاء الاصطناعي',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'تعليم الصُنّاع',
        desc: 'توفير مساحة للتجربة والاستكشاف وتعزيز نمو الطلاب الشامل',
      },
      item2: {
        title: 'افتح باب المعرفة',
        desc: 'من تطبيقات أجهزة الليزر إلى تعلم الحِزم والدورات، تلبية شاملة لاحتياجات تعلم مختلفة.',
      },
      item3: {
        title: 'حِزم الدورات',
        desc: 'أساسي لرفع كفاءة دورات ISTEAM بالذكاء الاصطناعي | تعليم الابتكار العلمي والتقني',
      },
    },
    resources: {
      title: 'موارد تعليم STEM الغنية',
      tabs: {
        laser: {
          name: 'قاطع ليزر',
          title: 'أجهزة الليزر',
          desc1: 'قاطع/نقاش ليزر مكتبي ذكي',
          desc2:
            'قطع عالي الدقة│تشغيل ذكي وسهل│معالجة عالية الكفاءة│آمن وصديق للبيئة',
        },
        software: {
          name: 'البرمجيات',
          title: 'برمجيات تعليمية',
          desc1: 'برمجيات شاملة متعددة الوظائف',
          desc2: 'المنصة السحابية | منصة التعلم | Light Maker',
        },
        ai: {
          name: 'مساعد تدريس ذكي بالذكاء الاصطناعي',
          title: 'مساعد تدريس ذكي',
          desc1: 'مراقبة فورية وتنبيهات الأجهزة',
          desc2: 'مساعد معلم بالذكاء الاصطناعي | لوحة مرئية',
        },
        kits: {
          name: 'الحِزم والدورات',
          title: 'حِزم دورات غنية',
          desc1: 'تعلم قائم على المشاريع PBL',
          desc2: 'مواد تعليمية مرافقة | تطبيق عملي',
        },
      },
    },
    different: {
      title: 'نحن المختلفون',
      items: {
        solution: {
          title: 'حلول تعليم بالذكاء الاصطناعي',
          desc: 'تعزيز فعالية التدريس وتجربة التعلم',
        },
        course: {
          title: 'دورات التفكير الإبداعي',
          desc: 'دورات مناسبة للأطفال من 3 إلى 16 عاماً',
        },
        product: {
          title: 'منتجات تعليم الابتكار العلمي والتقني',
          desc: 'صناعة بالليزر بنقرة واحدة',
        },
        space: {
          title: 'مساحة استكشاف الصُنّاع',
          desc: 'مزيج من الابتكار والعملية',
        },
      },
    },
    creative: {
      title: 'الإبداع يقود، نصنع المستقبل',
      machineDesc: 'آلة قص ونقش ليزر مكتبية ذكية',
      lightBlue530Desc: 'آلة قطع ونقش ليزر أزرق ذكية',
      markM20Desc: 'آلة وسم ليزر عالية الدقة',
      light640Desc: 'آلة قطع ونقش ليزر مكتبية احترافية',
    },
    innovation: {
      title: 'كيف نعزز التعلم الابتكاري؟',
      desc: 'تلتزم Zhongze للتعليم والعلوم بتطوير منتجات عالية الجودة لتعليم الابتكار العلمي والتقني، بما في ذلك قواطع الليزر وغيرها. تساعد هذه المنتجات الطلاب على التعلم التطبيقي في مجالات العلوم والتكنولوجيا والهندسة والفنون والرياضيات.',
      items: {
        steam: 'STEAM',
        coding: 'البرمجة',
        light530: 'استخدم Light 530',
        robotics: 'تقنيات الروبوتات',
      },
    },
    bottomBanner: {
      title: 'تطبيق تعليم الذكاء الاصطناعي على أرض الواقع',
      subtitle:
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
      desc: 'نركز على منتجات ليزر مخصصة وخدمات تقنية، لدعم المؤسسات التعليمية والشركات في دمج 【AI+التعليم】',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'برمجيات مخصصة لأجهزة الليزر  Light Maker',
      bannerDesc:
        'برنامج احترافي لأجهزة الليزر، بسيط وفعّال، يركز على تجربة القص والنقش.',
      bannerImageAlt: 'واجهة Light Maker',
      creationTitle: 'اجعل الإبداع أسهل',
      features: {
        proDesignTool: 'أدوات تصميم احترافية',
        highPrecisionParams: 'إعدادات معلمات عالية الدقة',
        multiDeviceControl: 'إدارة وتحكم متعدد الأجهزة',
        assetLibrary: 'نظام إدارة مكتبة مواد قوي',
      },
      intro: {
        imageAlt: 'عرض الوظائف',
        items: {
          item1: {
            title: 'نظام تصميم قوي وسهل الاستخدام',
            desc: 'برنامج إبداع قوي، متوافق مع تنسيقات JPG、DXF、AI、DST、PNG、BMP、TIF、SVG لتصميمات عالية الجودة.',
          },
          item2: {
            title: 'احترافية',
            desc: 'وظائف رسم احترافية تلبي جميع احتياجات التصنيع. سواء كان التصميم معقداً أو كان القص بسيطاً، يمكن التعامل معه بسهولة.',
          },
        },
      },
      downloadTitle: 'تنزيل البرنامج',
      downloadButton: 'تحميل للتجربة',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'منصة Zhongze للتعلم',
      bannerDescLine1:
        'منصة Zhongze للتعلم هي أداة تعلم عبر الإنترنت مبتكرة، تهدف إلى تزويد الطلاب والمعلمين بحل شامل لبرمجيات التعليم والعلوم.',
      bannerDescLine2:
        'سواء على الأجهزة المحمولة أو على الكمبيوتر، يمكن للمستخدمين الوصول إلى منصتنا واستخدامها بسهولة.',
      bannerImageAlt: 'واجهة منصة Zhongze للتعلم',
      exploreTitle: 'استكشف إمكانات بلا حدود، واصنع مستقبلاً رائعاً',
      exploreTabs: [
        { name: 'إنشاء' },
        { name: 'دليل المبتدئين' },
        { name: 'تعلم النمذجة' },
        { name: 'إنشاء بنقرة واحدة' },
        { name: 'توليد صور بالذكاء الاصطناعي' },
      ],
      tabContentAlt: 'عرض الوظائف',
      introTitle: 'منصة تعلم مبتكرة',
      introItems: [
        {
          title: 'تجربة تعلم جديدة عالية الكفاءة',
          desc: 'تدمج منصة Zhongze للتعلم في مكان واحد تعلم الدورات والتصميم الرسومي ووظائف قص الليزر. واجهة بطاقات بسيطة وواضحة، وتشغيل سلس وسهل، يربط التصميم الإبداعي بالإنتاج الفعلي بسلاسة، مع كفاءة عالية وسهولة في البدء.',
        },
        {
          title: 'ذكي وسهل، للمبتدئين بلا قلق',
          desc: 'مكتبات ضخمة مدمجة وإعدادات معلمات ذكية مسبقة؛ يمكنك الإنشاء بنقرة واحدة ليبدأ المبتدئون بسرعة. ودروس إرشادية مفصلة على الهاتف تجعل البداية بلا ضغط، مع مراقبة سحابية فورية لحالة الأجهزة لحماية سلامة التدريس طوال الوقت.',
        },
      ],
      introImageAlt: 'منصة تعلم مبتكرة',
      galleryAlt: 'عرض المنصة',
      downloadTitle: 'تنزيل البرنامج',
      downloadApps: [
        { name: 'تطبيق منصة Zhongze' },
        { name: 'برنامج تصميم Zhongze لسطح المكتب' },
      ],
      downloadButtonText: 'تحميل للتجربة',
    },
    cloudPlatform: {
      bannerTitle: 'منصة Zhongze السحابية',
      bannerDesc:
        'أداة إدارة تعليمية شاملة تدعم إرسال/استلام الواجبات، ومراقبة الأجهزة، وطلبات الصيانة، وإعدادات المعلمات، لمساعدة المعلمين والطلاب والمدارس على إدارة أكثر كفاءة.',
      bannerImageAlt: 'واجهة منصة Zhongze السحابية',
      exploreTitle: 'تبسيط إدارة التدريس',
      exploreTabs: [
        { name: 'إنشاء' },
        { name: 'دليل المبتدئين' },
        { name: 'تعلم متقدم' },
      ],
      tabContentAlt: 'عرض الوظائف',
      introTitle: 'رفع كفاءة التعليم',
      introItems: [
        {
          title: 'سهولة التشغيل',
          desc: 'إنشاء بنقرة واحدة: مكتبة صور وإعدادات معلمات مدمجة تدعم الإنشاء بنقرة واحدة لتبسيط خطوات التشغيل. مراقبة الأجهزة: متابعة فورية لحالة الأجهزة لضمان سير الأنشطة التعليمية بسلاسة.',
        },
        {
          title: 'إدارة موحدة',
          desc: 'ترابط الأجهزة: يدعم ربط أجهزة أخرى في غرفة الصُنّاع، مع إدارة بنقرة واحدة لرفع كفاءة الإدارة.',
        },
        {
          title: 'مراقبة فورية',
          desc: 'حالة الجهاز: متابعة حالة التشغيل في الوقت الحقيقي وطلب صيانة عند حدوث الأعطال. الصيانة الدورية: يذكّر النظام بالصيانة وفق مدة التشغيل وتكرار الاستخدام لإطالة عمر الجهاز وتحسين جودة القص.',
        },
      ],
      introImageAlt: 'منصة تعلم مبتكرة',
      galleryTitle: 'تطبيق تعليم الذكاء الاصطناعي على أرض الواقع',
      galleryDesc:
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
    },
  },
  eduServices: {
    banner: {
      title: 'AI+التعليم',
      desc: 'حلول Zhongze للتعليم للتحول الرقمي والذكي في التدريس، تدعم تنمية الكفاءات الابتكارية، وتنطلق من تطور التعليم واحتياجات الطلاب لتقديم حلول تعليم بالذكاء الاصطناعي لجميع المراحل لمدارس K-12.',
      imageAlt: 'بانر حلول التعليم',
    },
    recommended: {
      title: 'منتجات موصى بها',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'بناء مساحة تدريس شاملة',
      tabs: {
        'teaching-assist': 'مساعد تدريس ذكي',
        'process-optimize': 'تحسين سير التدريس',
        'device-manage': 'إدارة الأجهزة',
      },
      tabContents: {
        'teaching-assist': {
          title: 'مساعد تدريس ذكي',
          features: [
            '·مراقبة فورية وإدارة مستلزمات الأجهزة',
            '·مساعد تدريس ذكي بالذكاء الاصطناعي',
            '·لوحات متابعة مرئية',
          ],
        },
        'process-optimize': {
          title: 'تحسين سير التدريس',
          features: [
            '·إرسال الواجبات عبر الإنترنت وتصحيحها',
            '·إدارة مركزية عن بُعد لموارد الدورات السحابية',
          ],
        },
        'device-manage': {
          title: 'إدارة الأجهزة',
          features: [
            '·مراقبة فورية لأجهزة التعليم',
            '·طلب صيانة الأجهزة عن بُعد',
          ],
        },
      },
      categories: [
        {
          title: 'إرسال الواجبات عبر الإنترنت وتصحيحها',
          description: 'نظام إدارة واجبات ذكي يرفع كفاءة التدريس',
        },
        {
          title: 'طلب صيانة الأجهزة عن بُعد',
          description: 'خدمة صيانة وإصلاح عن بُعد سهلة ومريحة',
        },
        {
          title: 'إدارة مركزية عن بُعد، تبسيط سير التدريس',
          description: 'منصة إدارة عن بُعد موحدة لتحسين سير التدريس',
        },
        {
          title: 'موارد الدورات السحابية',
          description: 'موارد سحابية غنية للدورات ومواد التدريس',
        },
        {
          title: 'مراقبة فورية لأجهزة التعليم',
          description:
            'مراقبة حالة الأجهزة في الوقت الحقيقي لضمان سير التدريس بسلاسة',
        },
        {
          title: 'مساعد تدريس ذكي بالذكاء الاصطناعي',
          description: 'نظام مساعد تدريس ذكي مدفوع بالذكاء الاصطناعي',
        },
      ],
      solutionCards: [
        { title: 'حلول التحول الرقمي للابتكار العلمي والتقني' },
        { title: 'حلول الفصول الذكية لمرحلة K-12' },
        { title: 'حلول المهارات للتعليم المهني المتوسط والعالي' },
        { title: 'حلول فصول الجامعة بالذكاء الاصطناعي' },
      ],
    },
    solutions: {
      title: 'حلول تعليمية شاملة من مكان واحد',
      items: [
        {
          title: 'الأجهزة',
          description:
            'في سياق تمكين التعليم بالذكاء الاصطناعي، يعتمد قاطع الليزر من Henghao على دعم منصة سحابية ذكية ويتكامل بعمق مع منصة Zhongze السحابية لتدريس الليزر. يمكن للمعلمين إدارة الأجهزة عن بُعد وتوزيع المهام وتتبع تقدم الطلاب. هذا التكامل لا يرفع كفاءة التدريس فحسب، بل يمنح الطلاب تجربة تعلم أكثر تخصيصاً.',
          buttonText: 'عرض التفاصيل →',
        },
        {
          title: 'البرمجيات',
          description:
            'تدمج منصة Zhongze للتعليم تقنيات الذكاء الاصطناعي لتقديم تعلم مخصص وأدوات ذكية وتجارب تفاعلية وموارد سحابية، مع دعم إدارة الدورات والواجبات، ومراقبة الأجهزة والتنبيه المبكر، وتحليل البيانات. وبالاقتران مع منصة Zhongze للتعلم (APP/PC) وأداة Light Maker، تُسهم في دعم التدريس بشكل شامل وتحسين الموارد ودفع الابتكار التعليمي، وتقدم دعماً قوياً للمعلمين والطلاب والمؤسسات التعليمية.',
          buttonText: 'عرض التفاصيل →',
        },
        {
          title: 'الدورات',
          description:
            'دورات Zhongze للتعليم في قص الابتكار العلمي والتقني، هي دورات منهجية ووحداتية صُممت خصيصاً للناشئة لتحفيز الاهتمام وإطلاق الإمكانات. تشمل معارف تقنية وتفكيراً ابتكارياً ومشاريع تطبيقية وتجارب علمية، لمساعدة الأطفال على أن يصبحوا مواهب ابتكارية للمستقبل ودفع تطور المجتمع.',
          buttonText: 'عرض التفاصيل →',
        },
      ],
    },
    managementPlatform: {
      title: 'منصة Zhongze لإدارة التدريس الذكية',
      desc: 'تقدم مسارات تعلم مخصصة وأدوات تدريس ذكية وتجربة تعلم تفاعلية ومكتبة موارد سحابية، وتدعم إدارة الدورات وتتبع تقدم الطلاب والواجبات عبر الإنترنت والمراقبة الفورية لأجهزة التعليم والتنبيه المبكر وتحليل البيانات وغيرها. ومن خلال دمج تقنيات الذكاء الاصطناعي، تُحسن فعالية التدريس وتحقق تحسين توزيع الموارد التعليمية، وتوفر دعماً تعليمياً شاملاً للطلاب والمعلمين والمدارس والمؤسسات التعليمية، لدفع تطور التعليم والابتكار معاً.',
      items: [
        {
          title: 'حلول التحول الرقمي للابتكار العلمي والتقني',
          alt: 'حلول التحول الرقمي للابتكار العلمي والتقني',
        },
        {
          title: 'حلول الفصول الذكية لمرحلة K-12',
          alt: 'حلول الفصول الذكية لمرحلة K-12',
        },
        {
          title: 'حلول المهارات للتعليم المهني المتوسط والعالي',
          alt: 'حلول المهارات للتعليم المهني المتوسط والعالي',
        },
        {
          title: 'حلول فصول الجامعة بالذكاء الاصطناعي',
          alt: 'حلول فصول الجامعة بالذكاء الاصطناعي',
        },
      ],
      action: {
        text: 'احصل على حل مخصص',
        alt: 'أيقونة اتصل بنا',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'تعليم الصُنّاع — K12',
    },
    intro: {
      title: 'قاطع الليزر في التعليم والمدارس',
      desc: 'استخدام قاطع الليزر في المدرسة يجعل الرحلة من الفكرة إلى المنتج النهائي آمنة وغير تلامسية ورقمية. ويتيح بسهولة تحويل أفكار الأطفال الخلاقة إلى واقع.',
      imageAlt: 'قاطع الليزر أثناء تصنيع النماذج المعمارية',
    },
    scenesFeatured: {
      title: 'غيّر أسلوب التعلم بأدوات تعليمية متقدمة',
      desc: 'تقديم تقنيات رائدة على مستوى الصناعة للطلاب لتعزيز الإبداع والتفكير النقدي والمهارات التقنية.',
    },
    scenes: {
      items: [
        {
          title: 'منصة إبداع بالليزر لكل طالب',
          desc: 'تطبيق المفهوم عملياً وتدريب قدرة الطلاب على المشاركة، ليتمكنوا من تنمية التفكير الإبداعي في الصف بمساعدة أدوات قوية.',
        },
        {
          title: 'حِزم إلكترونيات وبرمجة',
          desc: 'استخدام حِزم تفاعلية لإشراك الطلاب في البرمجة العملية وتقنيات الروبوتات والذكاء الاصطناعي.',
        },
        {
          title: 'التعليم التقني والمهني',
          desc: 'منصة تقنيات الليزر تساعد على تمهيد المسار المهني ورفع المهارات للتكيف مع سوق عمل متغير وخلق فرص أكثر.',
        },
      ],
    },
    solutions: {
      title: 'تُستخدم النماذج المعمارية على نطاق واسع في مجالات عديدة',
      items: [
        { title: 'مدارس/مناطق K12' },
        { title: 'مراكز التدريب' },
        { title: 'مختبرات بحث ودورات تخصصية' },
        { title: 'مساحات الصُنّاع' },
        { title: 'مكتبات/متاحف العمارة' },
        { title: 'دورات إبداعية' },
      ],
    },
    bannerLeft: {
      title: 'تطبيق تعليم الذكاء الاصطناعي على أرض الواقع',
      subtitle:
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
    },
    products: {
      tabs: [
        {
          title: 'أجهزة الليزر',
          title1: 'أداة صنع مذهلة - قاطع الليزر',
          description:
            'تعتمد Light 530 وLight 640 على مكونات من الدرجة الأولى، مع عمليات تصنيع عالية الجودة وإجراءات فحص صارمة، لتقديم جهاز ليزر قوي عالي الأداء وثابت وبدقة ممتازة في القص والنقش، ويلبي باحتراف احتياجات الإبداع بالليزر في سيناريوهات تعليم الابتكار العلمي والتقني.',
        },
        {
          title: 'البرمجيات',
          title1: 'خبير الرسم -LightMaker',
          description:
            'يوفر للطلاب الأمان والسرعة والوظائف الذكية وتصميماً تقنياً من بين الأكثر ابتكاراً في السوق. LightMaker متوافق مع عدة برامج تصميم بما في ذلك AI وPS وCorelDRAW وAutoCAD وSolidworks وغيرها، ويدعم رفع ملفات عالية الجودة مثل JPG وDXF وAI وDST وPNG وBMP وTIF وSVG وغيرها.',
        },
        {
          title: 'الدورات',
          title1: 'تعليم متنوع - دورات الابتكار العلمي والتقني',
          description:
            'ندرك أن كل طفل فريد من نوعه، لذلك صُممت دوراتنا بشكل مرن ومتعدد لرفع اهتمام كل طالب وإطلاق إمكاناته. يشمل المحتوى—على سبيل المثال لا الحصر—أساسيات العلوم والتقنية، وتدريب التفكير الابتكاري، والتطبيقات القائمة على المشاريع، والتجارب العلمية وغيرها.',
        },
      ],
    },
    learning: {
      title:
        'كيف نستخدم قاطع الليزر من Zhongze للتعليم والعلوم في التعلم داخل الصف؟',
      teacher: {
        title: 'المعلم',
        lines: [
          'إعداد وسائل تعليمية ومرفقات للمواد',
          'يساعد قاطع الليزر المعلمين على إنتاج الوسائل التعليمية ومرفقات الصف بكفاءة عالية، كما يتيح لهم ابتكار أساليب تدريس أكثر حداثة.',
        ],
      },
      student: {
        title: 'الطالب',
        lines: [
          'تنمية المهارات العملية',
          'في الصف، يرافق قاطع الليزر الطلاب في تعلم التصميم والهندسة والتقنية وغيرها من المجالات المتداخلة، ويساعدهم على تحويل ما يتخيلونه إلى واقع.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'مشهد تصنيع نموذج معماري 1' },
        { alt: 'مشهد تصنيع نموذج معماري 2' },
        { alt: 'مشهد تصنيع نموذج معماري 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'نماذج معمارية - التعليم المهني',
    },
    intro: {
      title: 'كيف يُستخدم قاطع الليزر في تصنيع النماذج المعمارية؟',
      desc: 'يمكنك استخدام القص والنقش بالليزر لصناعة النماذج المعمارية وأصغر القطع في نماذج صناعة الألعاب. كما يمكنه قص المواد بدقة وسرعة مثل الأقمشة、البلاستيك、الخشب、الألواح المغطاة、MDF、PMMA、الكرتون、الورق、الرغوة、البوليسترين、الأغشية、الأكريليك وغيرها.',
      imageAlt: 'قاطع الليزر أثناء تصنيع النماذج المعمارية',
    },
    scenesFeatured: {
      title: 'قوة ثورية في تصنيع النماذج المعمارية',
      desc: 'يساعدك على إنجاز نماذج مصغرة دقيقة ونماذج معمارية عالية الجودة، لعرض مخططاتك الإبداعية بأناقة.',
    },
    scenes: {
      items: [
        {
          title: 'دقة عالية',
          desc: 'يمكن لقاطع الليزر قص المواد بدقة عالية للغاية، مع إمكانية التحكم في الخطأ ضمن نطاق صغير جداً، لضمان دقة أبعاد كل جزء من النموذج المعماري وتوافقه التام مع متطلبات المخططات.',
        },
        {
          title: 'مواد متنوعة',
          desc: 'يمكن إظهار الملمس الطبيعي للخشب وشفافية ولمعان الأكريليك وخفة ومرونة الورق عبر القص والنقش بالليزر، بما يمنح المنتج سحراً فريداً.',
        },
        {
          title: 'قدرة قوية على معالجة الأشكال المعقدة',
          desc: 'للأشكال الهندسية المعقدة والتفاصيل الدقيقة الشائعة في النماذج المعمارية، يمكن للقص بالليزر تنفيذها بسهولة مثل المنحنيات والهياكل غير المنتظمة وغيرها، مما يوفر مساحة إبداعية أكبر لصناعة النماذج.',
        },
      ],
    },
    solutions: {
      title: 'تُستخدم النماذج المعمارية على نطاق واسع في مجالات عديدة',
      items: [
        { title: 'الاستخدامات التعليمية والبحث الأكاديمي' },
        { title: 'صناعة النماذج وصناعة الألعاب' },
        { title: 'عناصر زخرفية وسمات معمارية' },
        { title: 'العقار والتخطيط الحضري' },
        { title: 'الديكور المعماري والتشطيبات' },
      ],
    },
    bannerLeft: {
      title: 'تطبيق تعليم الذكاء الاصطناعي على أرض الواقع',
      subtitle:
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
    },
    products: {
      tabs: [
        {
          title: ' المعدات المناسبة',
          title1: 'اختر المعدات المناسبة',
          description:
            'يمكن لأجهزة الليزر تحويل أفكار الطلاب بسرعة إلى منتجات فعلية، سواء كانت صناعة نماذج أو تصميماً أو إبداعاً فنياً. ومن الأعمال اليدوية البسيطة إلى التصميمات الميكانيكية المعقدة، يمكن لقاطع ونقاش الليزر تنفيذ المهام بدقة، ليتعلم الطلاب وينموا من خلال التطبيق العملي. ',
        },
        {
          title: 'التصميم الذاتي',
          title1: 'التصميم الذاتي',
          description:
            'عدّل التصميم بشكل مباشر واعرض المعاينة للنتيجة النهائية. قص وكرر تفاصيل أي تصميم على مواد متعددة: حسّن عملك باستخدام نصوص أو شعارات أو صور أو صور فوتوغرافية. ويمكنك تزيين نموذجك المعماري بسرعة.',
        },
        {
          title: 'سوقك',
          title1: 'رفع مهارات الطلاب',
          description:
            'آلة وسم ليزر محمولة مناسبة لوضع العلامات ونقش التفاصيل في النماذج المعمارية. سهلة التشغيل ومريحة الحمل، وهي أداة أساسية لتدريس العمارة.',
        },
      ],
    },
    learning: {
      title: 'تدريس دورات متعددة التخصصات',
      groups: [
        {
          title: 'نماذج مصغرة',
          lines: [
            'دقيق ومفصل ويلبي احتياجات الإبداع المصغر',
            'إظهار تفاصيل النقش/القص بالليزر بدقة على مواد متعددة، مع تجنب الإجراءات المعقدة وتجربة إبداع عالي الكفاءة وتقليل أخطاء العمل اليدوي.',
          ],
        },
        {
          title: 'التصميم الداخلي',
          lines: [
            'إنجاز تفاصيل التصميم من المرة الأولى؛ تتيح الكاميرا المدمجة معاينة موقع العنصر وحجمه بسهولة، وما تراه هو ما تحصل عليه. تنفيذ أعمال القص/النقش بفعالية وتقليل هدر المواد.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'مشهد تصنيع نموذج معماري 1' },
        { alt: 'مشهد تصنيع نموذج معماري 2' },
        { alt: 'مشهد تصنيع نموذج معماري 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'الفنون والحِرف - الجامعة',
    },
    intro: {
      title: 'كيف نستخدم أجهزة الليزر لمعالجة الأعمال الفنية والحِرف',
      desc: 'يوفر هذا الجهاز للطلاب منصة لتحويل الإبداع إلى منتجات فعلية، ويحفّز تفكيرهم الابتكاري وإبداعهم. يمكن للطلاب تصميم نماذج وأعمال فنية فريدة مثل قص الورق بالليزر والأختام وغيرها.',
      imageAlt: 'أجهزة الليزر أثناء معالجة الفنون والحِرف',
    },
    scenesFeatured: {
      title: 'تنمية المهارات التقنية',
      desc: 'من خلال تشغيل قاطع/نقاش الليزر، يتعلم الطلاب معرفة أعمق في علوم المواد وتقنيات المعالجة، ويطورون المهارات العملية وقدرات حل المشكلات.',
    },
    scenes: {
      items: [
        {
          title: 'تحفيز التفكير الإبداعي',
          desc: 'يمكن استخدام قاطع/نقاش الليزر لتنفيذ تصميمات الطلاب الإبداعية مثل صناعة النماذج والأعمال الفنية، بما يعزز إبداعهم.',
        },
        {
          title: 'تكامل متعدد التخصصات',
          desc: 'تشمل تقنيات القص والنقش بالليزر معارف من عدة تخصصات مثل الفيزياء والكيمياء وعلوم المواد وعلوم الحاسوب وغيرها. وفي التعليم الجامعي، يمكنها تعزيز التقاطع بين التخصصات وتنمية الكفاءة الشاملة لدى الطلاب.',
        },
        {
          title: 'مشاريع تعليمية تطبيقية',
          desc: 'يمكن استخدام تقنيات القص والنقش بالليزر في المشاريع التطبيقية بالجامعة مثل التدريب الهندسي والتصميم الفني والإبداع الثقافي وغيرها. على سبيل المثال، يمكن للطلاب استخدام قاطع/نقاش الليزر لصنع نماذج معمارية وقطع ميكانيكية ومنحوتات فنية، للجمع بين المعرفة النظرية والتطبيق العملي.',
        },
      ],
    },
    solutions: {
      title: 'تطبيقات صناعة الحِرف في الجامعة',
      items: [
        { title: 'منتجات تجزئة مخصصة' },
        { title: 'تخصيص الهدايا' },
        { title: 'تسويق المناسبات' },
        { title: 'إكسسوارات المجوهرات' },
        { title: 'ملابس مخصصة' },
      ],
    },
    bannerLeft: {
      title: 'تطبيق تعليم الذكاء الاصطناعي على أرض الواقع',
      subtitle:
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
    },
    products: {
      tabs: [
        {
          title: ' المعدات المناسبة',
          title1: 'اختر المعدات المناسبة',
          description:
            'من خلال اختيار أجهزة قص/نقش ليزر مناسبة، يمكن للجامعة تزويد الطلاب بأدوات تعليمية تطبيقية متقدمة وتحفيز إبداعهم، وفي الوقت نفسه رفع جودة التدريس وكفاءته.',
        },
        {
          title: 'التصميم الذاتي',
          title1: 'التصميم الذاتي',
          description:
            'عدّل التصميم بشكل مباشر واعرض المعاينة للنتيجة النهائية. انقش وكرر تفاصيل أي تصميم على مواد متعددة: حسّن عملك باستخدام نصوص أو شعارات أو صور أو صور فوتوغرافية. نقاش الليزر سهل الاستخدام جداً ويمكنه تزيين أعمالك الفنية بسرعة.',
        },
        {
          title: 'الفن والتصميم',
          title1: 'تدريس تخصصات الفن والتصميم',
          description:
            'في تخصصات مثل التصميم الفني والتصميم الصناعي وغيرها، تُستخدم أجهزة قص/نقش الليزر على نطاق واسع في مشاريع تصميم المقررات ومشاريع التخرج. يمكن للطلاب تحويل أفكار التصميم بسرعة إلى نماذج فعلية وتدريب قدرة تطوير النماذج الأولية للمنتجات.',
        },
      ],
    },
    learning: {
      title: 'أدخل الليزر إلى المدرسة',
      groups: [
        {
          title: 'دقة وكفاءة، توفير للوقت والجهد',
          lines: [
            'يدعم قاطع الليزر من Zhongze المعاينة بالكاميرا مع محاذاة دقيقة دون إهدار للمواد، حتى للمبتدئين يمكن البدء بسهولة.',
            'تشغيل سلس وبسيط؛ ضع المادة وابدأ التصميم الإبداعي، وما تراه هو ما تحصل عليه.',
            'إبداع دقيق مع الاستفادة المثلى من كل قطعة مادة، وتوفير للوقت والجهد والمواد.',
          ],
        },
        {
          title: 'أداء عالي القدرة، يتعامل بسهولة مع مواد متنوعة',
          lines: [
            'مزود بليزر CO₂ عالي القدرة، يتقن النقش والقص.',
            'يمكنه قص ونقش الأكريليك والخشب والخيزران وغيرها من المواد بسهولة، ويبني سير عمل مناسباً لهواة الأعمال اليدوية لتصبح عملية الإبداع أبسط وأكثر كفاءة.',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'مشهد تصنيع الفنون والحِرف 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'تصميم ثقافي وإبداعي — التعليم المهني العالي',
    },
    intro: {
      title: 'أجهزة الليزر في التصميم الثقافي والإبداعي',
      desc: 'غالباً ما تُجهّز تخصصات التصميم الثقافي والإبداعي في المعاهد المهنية العليا بأجهزة قص/نقش ليزر متقدمة مثل نقاشات الليزر وغيرها، لتلبية احتياجات التعليم التطبيقي للطلاب في مختلف المراحل.',
      imageAlt: 'أجهزة الليزر في التصميم الثقافي والإبداعي',
    },
    scenesFeatured: {
      title: 'افتح إمكانات لا حدود لها للإبداع والجودة',
      desc: 'بفضل أدائه المتميز وقدرته الدقيقة على القص، أصبح أداة فعّالة لا غنى عنها في يد مصممي المنتجات الثقافية والإبداعية.',
    },
    scenes: {
      items: [
        {
          title: 'قص عالي الدقة لعرض تفاصيل التصميم بشكل مثالي',
          desc: 'للأنماط المعقدة والدقيقة والأشكال الفريدة في التصميم الثقافي والإبداعي، يمكن لقاطع الليزر إعادة تنفيذها بدقة، لضمان ظهور كل تفصيل بشكل صحيح على المنتج النهائي.',
        },
        {
          title: 'معالجة مواد متنوعة',
          desc: 'يمكن لأجهزة الليزر التعامل مع مواد متعددة مثل الخشب والأكريليك والجلد والمعادن وغيرها، ما يوفر خيارات غنية لمواد تصميم المنتجات الثقافية والإبداعية.',
        },
        {
          title: 'تشغيل ذكي لتبسيط تنفيذ الأفكار الإبداعية',
          desc: 'ما على الطلاب سوى إدخال النمط المصمم إلى الحاسوب، ليقوم قاطع الليزر بالتعرف عليه تلقائياً وإجراء قص دقيق. هذا التشغيل الذكي لا يقلل متطلبات الخبرة الفنية للمشغلين فحسب، بل يرفع أيضاً استقرار وموثوقية عملية الإنتاج.',
        },
      ],
    },
    solutions: {
      title: 'إدخال المزيد من التصاميم الجيدة إلى الحياة',
      items: [
        { title: 'لوحات ديكور بموضوعات ثقافية' },
        { title: 'تصميم إضاءة إبداعية' },
        { title: 'تحف وإكسسوارات منزلية' },
        { title: 'حامل أقلام وصناديق تنظيم القرطاسية' },
        { title: 'إكسسوارات بطابع تراثي' },
        { title: 'هدايا تذكارية سياحية' },
      ],
    },
    bannerLeft: {
      title: 'تطبيق تعليم الذكاء الاصطناعي على أرض الواقع',
      subtitle:
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
    },
    learning: {
      title:
        'أدوات الإنتاج في التصميم الثقافي والإبداعي بالمعاهد المهنية العليا',
      groups: [
        {
          title: 'تخصيص شخصي',
          lines: [
            'يمكن لقاطع/نقاش الليزر تنفيذ تخصيص شخصي للصور أو الأسماء أو الأنماط الخاصة بسهولة، لتلبية طلب المستهلكين على هدايا فريدة وذات قيمة تذكارية.',
            'على سبيل المثال، يمكن نقش أنماط أو نصوص يحددها المستهلك على تحف خشبية وإكسسوارات جلدية وزينة أكريليك وغيرها من المنتجات الثقافية والإبداعية لتصبح أكثر خصوصية.',
          ],
        },
        {
          title: 'إنتاج منتجات مشتقة ثقافية وإبداعية',
          lines: [
            'من هدايا المتاحف التذكارية إلى المنتجات المشتقة من الأفلام والأنمي، يجعل قاطع/نقاش الليزر التصاميم المعقدة مرئية وقابلة للتسويق.',
            'يمكنه تحويل عناصر مثل المعالم الشهيرة والمباني الرمزية والملكية الثقافية (IP) إلى منتجات واقعية؛ مثل قص لوح خشبي عادي إلى زينة بنمط وشكل فريدين، أو نقش ورقة عادية لتصبح عملاً فنياً رائعاً.',
          ],
        },
        {
          title: 'إبداعات DIY',
          lines: [
            'تساعد أجهزة الليزر هواة الأعمال اليدوية على تحقيق مستوى أعلى من إبداعات DIY؛ من الحِرف الصغيرة إلى ديكور منزلي فريد، يمكن تنفيذها بسرعة عبر تقنيات الليزر.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'مشهد التصميم الثقافي والإبداعي 1' },
        { alt: 'مشهد التصميم الثقافي والإبداعي 2' },
        { alt: 'مشهد التصميم الثقافي والإبداعي 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'التعاون التعليمي',
    },
    advantages: {
      title: 'مزايا تعاوننا',
      items: [
        {
          title: 'فريق بحث وتطوير ذو خبرة',
          desc: 'يمتلك Zhongze للتعليم والعلوم فريقاً محترفاً يضم مهندسين ومختصين في تعليم STEM، ويطوّر باستمرار منتجات مبتكرة تلبي معايير تعليمية عالية وتجذب الطلاب.',
        },
        {
          title: 'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم',
          desc: 'منصة Zhongze الذكية للتعليم: تعلم شخصي، أدوات ذكية، وتجربة تفاعلية. تدعم إدارة الدورات وتتبع التقدم وتسليم الواجبات، ومراقبة الأجهزة وتحليل البيانات، مع موارد سحابية غنية لجعل التدريس أكثر كفاءة.',
        },
        {
          title: 'حِزم ومنظومة دورات غنية',
          desc: 'نقدم دورات من المستوى المبتدئ إلى المتقدم في قص الليزر والمنزل الذكي والنقل الذكي وغيرها، لتلبية احتياجات الطلاب من مختلف الفئات العمرية.',
        },
      ],
    },
    modes: {
      title: 'نماذج التعاون',
      carouselAlts: [
        'مشهد التعاون التعليمي',
        'حصة التعاون التعليمي',
        'تطبيق التعاون التعليمي',
      ],
      items: [
        {
          title: 'إدخال المناهج',
          desc: 'يمكن للمؤسسات الشريكة إدخال منظومة دوراتنا مباشرة لرفع جودة التدريس بسرعة.',
        },
        {
          title: 'حِزم تعليمية',
          desc: 'الحِزم مصممة خصيصاً للأطفال من عمر 3 إلى 16 عاماً. ومن خلال مواد تجارب آمنة وسهلة الاستخدام، تُلهم الأطفال الاهتمام بالعلوم والتقنية والهندسة والفنون والرياضيات (STEAM).',
        },
        {
          title: 'تعاون المنتجات',
          desc: 'يمكن للمؤسسات الشريكة شراء منتجاتنا التعليمية مثل آلات قص الليزر لاستخدامها في التدريس وتطبيقات الطلاب العملية.',
        },
        {
          title: 'بحث وتطوير مشترك',
          desc: 'نرحب بمشاركة المؤسسات الشريكة في تطوير الدورات والمنتجات لدفع الابتكار التعليمي معاً.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'تحويل تعليم الذكاء الاصطناعي إلى واقع',
        'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'مركز التنزيلات',
      sectionTitle: 'تنزيل البرمجيات',
      downloadButtonText: 'تنزيل العميل',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'تطبيق منصة Zhongze للتعلم' },
        { name: 'منصة Zhongze للتعلم' },
      ],
    },
    afterSales: {
      bannerTitle: 'خدمة ما بعد البيع',
      serviceTitle: 'خدمات AR الذكية',
      serviceItems: [
        {
          title: 'تشخيص عن بُعد',
          desc: 'إرشاد AR عن بُعد: يطّلع فريق الدعم الفني على حالة الجهاز في الوقت الفعلي، ويشخّص الأعطال بسرعة، ويقدّم توصيات حلول دقيقة.',
        },
        {
          title: 'صيانة افتراضية',
          desc: 'عرض عمليات AR: عرض افتراضي لخطوات الصيانة بشكل بصري وسهل الفهم لمساعدتك على إتقان الطريقة بسرعة.',
        },
        {
          title: 'إرشادات ذكية',
          desc: 'تعلم تفاعلي عبر AR: عرض دليل التشغيل مباشرة على الجهاز بكفاءة وسهولة.',
        },
        {
          title: 'استجابة سريعة',
          desc: 'دعم فوري عبر AR: استجابة سريعة تقلل وقت الانتظار وتجعل حل المشكلات أكثر كفاءة.',
        },
      ],
      videosTitle: 'فيديوهات التشغيل',
      playButtonText: 'تشغيل الفيديو',
      videos: [
        { title: 'عرض فيديو فك التغليف' },
        { title: 'طرق توصيل اتصال الجهاز' },
        { title: 'دليل استخدام Light 530' },
        { title: 'دليل التركيب بعد فتح العلبة' },
        { title: 'العمليات الأساسية للبرنامج' },
        { title: 'استكشاف الأعطال الشائعة' },
      ],
      manualsTitle: 'دليل التشغيل',
      viewPdfButtonText: 'عرض ملف PDF',
      manuals: [
        { title: 'إرشادات تشغيل Light 530' },
        { title: 'إرشادات تشغيل Light 640' },
        { title: 'دليل استخدام Blue 530' },
        { title: 'دليل صيانة M20' },
        { title: 'دليل السلامة لقص الليزر' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'ثلاث سلاسل رئيسية من الحِزم',
      bannerDesc:
        'تدعم الحِزم التعلم الشخصي وتلائم الطلاب من مختلف الأعمار واحتياجات التعلم، كما توفر للمعلمين موارد وأدوات تدريس غنية لمساعدتهم على التدريس والتوجيه بشكل أكثر فاعلية.',
      sections: {
        educationTitle: 'حِزم تعليمية',
        educationDesc: 'تنمية التفكير الابتكاري والإبداع',
        creativityTitle: 'الإبداع يقود، نصنع المستقبل',
        projectsTitle: 'مشاريع تعليمية متنوعة',
      },
      kitsTabs: [
        {
          name: 'حزمة مدخل إلى قص الليزر',
          title: 'حزمة مدخل إلى قص الليزر\n(مع ألواح خشبية ومواد استهلاكية)',
          desc: 'دورات STEAM لقص الليزر، مصممة وفق نظرية الذكاءات المتعددة وفلسفة تعليم STEAM ونظرية التعلم القائم على المشاريع. تستهدف فئات عمرية مختلفة لتنمية القدرة على الابتكار والتفكير النقدي وحل المشكلات، إضافة إلى مهارات التواصل وروح العمل الجماعي. ',
        },
        {
          name: 'صندوق العلوم العجيب',
          title: 'صندوق العلوم العجيب\n(مع ألواح خشبية + حزمة دوائر مصغّرة)',
          desc: 'ترتبط الدروس ارتباطاً وثيقاً بـ «معايير منهج العلوم للتعليم الإلزامي (إصدار 2022)»، وتتمحور حول أربعة أبعاد: المفاهيم العلمية، التفكير العلمي، الممارسة الاستقصائية، والمسؤولية والاتجاهات؛ لتنمية الكفاءات الأساسية لدى الطلاب. يُنجز الطلاب في كل درس عملاً علمياً واحداً، يغطي مفاهيم محورية مثل الحِرف التقليدية والهندسة التقنية والمجتمع وغيرها، ويقودهم للتفكير كالعلماء وتحسين مهارات الاستقصاء وبناء التفكير العلمي.',
        },
        {
          name: 'حزمة برمجة الذكاء الاصطناعي',
          title: 'حزمة برمجة الذكاء الاصطناعي',
          desc: 'استكشف تقنيات المستقبل بدءاً من حزمة برمجة الذكاء الاصطناعي. تتضمن حِزم المزرعة الذكية والمنزل الذكي والنقل الذكي والمصنع الذكي، لتعرّف الطلاب على التقنيات الزراعية وتجربة الحياة الحديثة واستكشاف كفاءة النقل وفهم التصنيع الذكي. تحفّز الممارسة العملية التفكير الابتكاري وتنمي مهارة حل المشكلات، لتساعد على الاستعداد لعالم ذكي.',
        },
      ],
      creativityItems: [
        {
          title: 'تعزيز المهارات العملية',
          desc: 'تدمج هذه الحِزم تعليم STEMA (العلوم، التقنية، الهندسة، الفنون، الرياضيات). ومن خلال العمل اليدوي والمشاريع التطبيقية، تعزز بصورة شاملة مهارات الطلاب العملية وقدرتهم على حل المشكلات.',
        },
        {
          title: 'تنمية التفكير الابتكاري',
          desc: 'تشجع الطلاب على التصميم والتجريب بشكل مبتكر لتنمية التفكير الابتكاري والإبداع. وفي مشاريع الفريق، تعزز مهارات التواصل والتعاون.',
        },
        {
          title: 'مساندة التدريس للمعلمين',
          desc: 'تشجع الطلاب على التصميم والتجريب بشكل مبتكر لتنمية التفكير الابتكاري والإبداع. وفي مشاريع الفريق، تعزز مهارات التواصل والتعاون.',
        },
      ],
      projectItems: [
        { title: 'العلوم' },
        { title: 'التقنية' },
        { title: 'البرمجة' },
        { title: 'الفنون' },
      ],
      bottomBannerText:
        'تعزز الدروس مهارات الطلاب العملية وحل المشكلات الواقعية عبر العمل اليدوي والمشاريع التطبيقية؛ وتنمي التفكير الابتكاري والإبداع وتشجع على التصميم والتجريب المبتكر. ترفع مشاريع الفريق مهارات التواصل والتعاون وتعلّم العمل الجماعي. كما تتيح التعرف إلى أحدث التقنيات والأدوات لمساعدة الطلاب على تلبية متطلبات مجتمع المستقبل.',
    },
    courses: {
      bannerTitle: 'منظومة الدورات',
      bannerDesc:
        'دورات STEAM ممنهجة مصممة لطلاب من مختلف الأعمار، تدمج العلوم والتقنية والهندسة والفنون والرياضيات لتنمية مبتكري المستقبل.',
      bannerAlt: 'منظومة الدورات',
      bottomBannerAlt: 'عرض دورات منظومة الدورات',
      sections: {
        kitsTitle: 'حِزم الدورات',
        kitsDesc: 'تكامل مثالي بين العتاد والبرمجيات',
        seriesTitle: 'سلسلة الدورات المميزة',
      },
      courseTabs: [
        {
          name: 'العمر 3-6 سنوات',
          title: 'منظومة استكشاف العلوم - الطفولة المبكرة (6 دروس)',
          desc: 'انطلاقاً من ظواهر مألوفة في الحياة اليومية، يستخدم الطلاب أدوات تعليمية علمية للاستكشاف بشكل أعمق لفهم القوانين والمبادئ التي تحكم تطور الأشياء.',
        },
        {
          name: 'العمر 6-12 سنة',
          title: 'منظومة صُنّاع STEAM - اليافعون (3 دروس)',
          desc: 'إطلاق الإبداع الشخصي والقدرة على استخدام الأجهزة والعمل باليد لتحويل الأفكار إلى أعمال.',
        },
        {
          name: 'العمر 8-13 سنة',
          title: 'منظومة دورات قص الليزر (3 دروس)',
          desc: 'استخدام الجهاز لقص مكونات بنيوية مختلفة وتجميعها في هيكل ثلاثي الأبعاد وتجميل الشكل. مهارات البرمجة: فهم منطق ومبادئ أحكام البرمجة.',
        },
        {
          name: 'العمر 6-15 سنة',
          title: 'منظومة دورات الذكاء الاصطناعي (4 دروس)',
          desc: 'استخدام أدوات الأجهزة لتصميم وصنع مظهر الأعمال، ثم عبر البرمجة جعل الأعمال أكثر ذكاءً وبساطة وقادرة على حل مشكلات الحياة اليومية. مهارات البرمجة: فهم منطق ومبادئ أحكام البرمجة وتعلم صياغة برمجة Arduino.',
        },
      ],
      introItems: [
        {
          title: 'تركيز قوي على التطبيق العملي',
          desc: 'يركز تصميم الدروس على التطبيق؛ يَستخدم الطلاب آلات قص الليزر وغيرها بأيديهم لتحويل النظرية إلى مهارات عملية.',
        },
        {
          title: 'تنمية التفكير الابتكاري',
          desc: 'تشجع الدروس الطلاب على التصميم والصنع الإبداعيين لتنمية التفكير الابتكاري وقدرة حل المشكلات.',
        },
        {
          title: 'تعلم قائم على المشاريع',
          desc: 'تعتمد الدروس أسلوب التعلم القائم على المشاريع؛ ومن خلال إنجاز مهام مشروع محددة، يتعلم الطلاب ويُتقنون المعرفة عبر الممارسة.',
        },
        {
          title: 'استكشاف أحدث التقنيات',
          desc: 'تعلم قائم على المشاريع؛ يتعلم الطلاب عملياً أثناء إنجاز مهام مشروع محددة لإتقان المعرفة.',
        },
        {
          title: 'تدريس ممنهج',
          desc: 'تتدرج الدروس من المستوى المبتدئ إلى المتوسط، وتدرّس تقنيات قص الليزر بشكل ممنهج لمساعدة الطلاب على بناء قاعدة معرفية متينة.',
        },
        {
          title: 'متعة وتحدٍ معاً',
          desc: 'يجمع تصميم الدروس بين المتعة والتحدي لتحفيز اهتمام الطلاب بالتعلم ورغبتهم في الاستكشاف.',
        },
      ],
      courseListRow1: [{ name: 'المزرعة الذكية' }, { name: 'المنزل الذكي' }],
      courseListRow2: [{ name: 'النقل الذكي' }, { name: 'المصنع الذكي' }],
      bottomBannerText:
        'تتميز الدروس بالتطبيق العملي والتفكير الابتكاري والتكامل متعدد التخصصات، وتعتمد التعلم القائم على المشاريع لتمكين الطلاب من إتقان التقنيات المتقدمة وسط المتعة والتحدي. وبدمج التدريس الممنهج وتعليم السلامة والتعلم الشخصي، تنمّي المهارات اليدوية وروح العمل الجماعي وقدرة حل المشكلات، وتشجع على عرض النتائج لتعزيز شعور الطلاب بالإنجاز.',
    },
    kitsAccessories: {
      bannerTitle: 'ملحقات الحِزم',
      accessories: [
        { name: 'شريط إضاءة RGB' },
        { name: 'وحدة الساعة DS1307' },
        { name: 'مستشعر الحرارة والرطوبة DHT11' },
        { name: 'مستشعر الحركة' },
        { name: 'وحدة إضاءة LED' },
        { name: 'وحدة المروحة' },
        { name: 'مفتاح قاطع ضوئي شقي' },
        { name: 'وحدة الزر' },
        { name: 'لوحة التحكم' },
        { name: 'لوحة التوسعة' },
        { name: 'مستشعر قطرات المطر' },
        { name: 'محرك TT مع لوحة محول' },
        { name: 'وحدة استشعار بالأشعة تحت الحمراء' },
        { name: 'جهاز تحكم بالأشعة تحت الحمراء' },
        { name: 'مستشعر الغاز' },
        { name: 'وحدة شاشة رقمية رباعية' },
        { name: 'لوحة مفاتيح مصفوفية' },
        { name: 'مستشعر ضوئي' },
        { name: 'وحدة إشارة مرور' },
        { name: 'صفّارة' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'آلة قص ونقش ليزر مكتبية ذكية',
      sections: {
        advantages: 'مزايا منتجاتنا',
        aiTitle: 'تحويل تعليم الذكاء الاصطناعي إلى واقع',
        aiSubtitle:
          'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
        carouselTitle: 'إمكانات لا نهائية للنقش بالضوء',
        specsTitle: 'مواصفات المنتج',
      },
      bannerFeatures: [
        'تصوير موضعي / تتبّع الأشكال / حماية أمان',
        'مطوّر خصيصاً لتعليم STEAM وصُنّاع الماكِر',
      ],
      softwareSection: {
        title: 'نظام قص ليزر سهل التشغيل وقوي الوظائف',
        items: [
          'إمكانية ضبط معلمات عمليات مختلفة بحسب المادة، مثل: القص، النقش العميق، النقش السطحي، المسح وغيرها.',
          'مكتبة غنية من قوالب الرسومات ترفع كفاءة التصميم للمستخدم.',
          'تدعم الكاميرا التصوير الموضعي والمساعدة في تصميم الأشكال لتحويل الإبداع إلى واقع.',
        ],
      },
      advantages: [
        {
          tagTitle: 'ليزر عالي الجودة وعالي الدقة',
          desc: 'مثل أنبوب ليزر CO₂ مستورد أصلياً بطول موجي 10640nm وقدرة ليزر مستمرة 50W. يصل أقصى سمك قص إلى 15mm (أكريليك). تصل سرعة العمل إلى 1000mm/s، ودقة إعادة التموضع 0.025mm. يضمن دقة عالية لقص ونقش أعمال إبداعية دقيقة بسرعة وبإتقان.',
        },
        {
          tagTitle: 'نظام ترشيح ثلاثي مدمج للعادم',
          desc: 'هيكل مدمج يجمع مرشحاً وشحماً كربونياً نشطاً وطبقة UV/أوزون لترشيح الدخان والغبار، ما يجعله أنظف وأكثر صداقة للبيئة، كما يسهل وضع الجهاز بشكل أكثر إحكاماً دون الحاجة لشراء صندوق ترشيح منفصل أو شغل مساحة إضافية.',
        },
        {
          tagTitle: 'حماية أمان بأعلى أولوية',
          desc: 'اجتاز أعلى اختبارات السلامة في مختبرات SGS، وهو منتج ليزر من الفئة الأولى معتمد من FDA. يتميز بتصميم فريد لمؤشرات حالة الأمان والتشغيل لعرض حالة تشغيل الجهاز بوضوح وبشكل مباشر.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: 'نوع الليزر', value: 'أنبوب ليزر زجاجي CO₂ محكم الإغلاق' },
          { label: 'مدى رفع/خفض رأس الليزر', value: '≤25mm' },
          { label: 'سماكة المواد المسموح بها', value: '≤22mm' },
          { label: 'طريقة التركيز', value: 'تركيز تلقائي، تركيز يدوي' },
          {
            label: 'طريقة الاتصال',
            value: 'يدعم اتصال USB واتصال LAN واتصال WiFi',
          },
          { label: 'أنظمة التشغيل المدعومة', value: 'Windows وiOS' },
          {
            label: 'برامج التصميم المدعومة',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks وغيرها',
          },
          {
            label: 'تنسيقات الملفات المدعومة',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG وغيرها',
          },
          { label: 'عمر الليزر', value: '≤9000 ساعة' },
          {
            label: 'برمجيات التشغيل',
            value: 'LightMaker(سطح المكتب والجوال), Lightburn(سطح المكتب)',
          },
          {
            label: 'طريقة التحكم',
            value: 'شاشة لمس LCD مقاس 5 بوصات/تطبيق الهاتف/برنامج الحاسوب',
          },
          { label: 'ضوضاء التشغيل', value: '≤60db' },
          {
            label: 'نظام الحركة',
            value: 'محرك خطوي عالي السرعة + سكة خطية عالية الدقة + حزام متزامن',
          },
          {
            label: 'الحماية والسلامة',
            value:
              'مفتاح تعشيق: يتوقف عند فتح الغطاء، توقف فوري عند الصدمة، زر طوارئ، مفتاح أمان، مؤشر حالة التشغيل، إنذار ارتفاع حرارة خزان المياه',
          },
          { label: 'نظام التغذية الكهربائية', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'وزن الجهاز', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          { label: 'طريقة التبريد', value: 'نظام تبريد مائي مدمج (ماء فعّال)' },
          {
            label: 'جهد التشغيل',
            value: 'تيار مستمر 24V تبريد بالهواء + ملف ألمنيوم',
          },
          { label: 'سعة خزان المياه', value: '3.2L' },
          { label: 'أقصى ارتفاع ضخ', value: '5M' },
          {
            label: 'معدل تدفق المياه',
            value:
              '1000L/H أو مبرد مياه ليزر خارجي مخصص من طراز CW3000 (اختياري)',
          },
        ],
        airPumpSpecs: [
          { label: 'معدل الهواء', value: '50L/min' },
          { label: 'الضوضاء', value: '≤48dB' },
          { label: 'الضغط', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'القدرة المقننة', value: '62W' },
          { label: 'تدفق الهواء', value: '280m³/H' },
          { label: 'الضوضاء', value: '≤50dB' },
          { label: 'الجهد', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle: 'معلمات نظام التبريد المائي (مدمج)',
          airPumpTitle: 'معلمات مضخة الهواء (مدمجة)',
          airPumpValueOnly: 'AC 220V/110V 16W',
          exhaustTitle: 'معلمات نظام شفط الهواء (خارجي مدمج) سحب جانبي/سفلي',
          filterTitle: 'نظام الترشيح',
          filterValue:
            'قطن ترشيح كربون نشط + مروحة هادئة + لوح كربون نشط صناعي',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'آلة قص ونقش ليزر أزرق ذكية',
      sections: {
        advantages: 'مزايا منتجاتنا',
        aiTitle: 'تحويل تعليم الذكاء الاصطناعي إلى واقع',
        aiSubtitle:
          'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
        carouselTitle: 'إمكانات لا نهائية للنقش بالضوء',
        specsTitle: 'مواصفات المنتج',
      },
      bannerFeatures: [
        'معالجة مواد متعددة',
        'اصنع بثقة، وابتكر بسهولة في أي وقت',
      ],
      advantages: [
        {
          tagTitle: 'المظهر ومساحة الإشغال',
          desc: 'آلة النقش بالليزر الأزرق بتصميم عصري وأنيق ومدمج، تناسب وضعها في المنزل أو المدرسة أو الاستوديو. يتيح الجمع بين الهيكل المعدني وغطاء الأكريليك رؤية عملية المعالجة بوضوح.',
        },
        {
          tagTitle: 'معالجة مغلقة لتفادي الأذى',
          desc: 'آلة النقش بالليزر الأزرق مغلقة بالكامل؛ إذا فُتح الغطاء أثناء التنفيذ تتوقف تلقائياً. وفي حالات الطوارئ يمكن إيقاف الجهاز فوراً بمفتاح واحد. مناسبة للاستخدام في المنزل والمدرسة.',
        },
        {
          tagTitle: 'معالجة مواد متعددة، دعم لمئات المواد',
          desc: 'خصّص سلسلة منتجات بأشكال أو أنماط فريدة. ويمكن إضافة ملحقات لتمكين نقش مواد بأشكال مختلفة مثل الأكواب والأجسام الأسطوانية، ما يجعله مثالياً لاحتياجات الأعمال الصغيرة.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'نظام التبريد',
          airPumpTitle: 'معلمات مضخة الهواء',
          airPumpValueOnly: '—',
          exhaustTitle: 'نظام العادم',
          filterTitle: 'نظام الترشيح',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: 'نوع الليزر', value: 'ليزر أزرق' },
          { key: 'laserPower', label: 'قدرة الليزر', value: '20W / 40W' },
          { key: 'maxCutThickness', label: 'أقصى سمك قص', value: '≤10mm' },
          { key: 'focusMode', label: 'طريقة التركيز', value: 'تركيز يدوي' },
          { key: 'connection', label: 'طريقة الاتصال', value: 'اتصال USB' },
          {
            key: 'os',
            label: 'أنظمة التشغيل المدعومة',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'برمجيات التشغيل',
            value: 'LightBurn (سطح المكتب)',
          },
          {
            key: 'laserLifetime',
            label: 'عمر الليزر',
            value: '≥10000 ساعة',
          },
          {
            key: 'maxMaterialThickness',
            label: 'سماكة المواد المسموح بها',
            value: '15mm',
          },
          { key: 'noise', label: 'ضوضاء التشغيل', value: '≤60dB' },
          { key: 'engraveSpeed', label: 'سرعة النقش', value: '600mm/s' },
          {
            key: 'designSoftware',
            label: 'برامج التصميم المدعومة',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks وغيرها',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          { key: 'maxSpeed', label: 'أقصى سرعة عمل', value: '1000mm/s' },
          {
            key: 'power',
            label: 'نظام التغذية الكهربائية',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          { key: 'workTable', label: 'أبعاد منصة العمل', value: '520 × 315mm' },
          { key: 'accuracy', label: 'دقة التمركز', value: '±0.01mm' },
          {
            key: 'repeatAccuracy',
            label: 'دقة إعادة التمركز',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'متطلبات الطاقة',
            value: 'AC 220V ±10%，50Hz',
          },
          { key: 'totalPower', label: 'قدرة الجهاز', value: '300W' },
          {
            key: 'transmission',
            label: 'نظام الحركة',
            value: 'محرك خطوي عالي السرعة + سكة خطية عالية الدقة + حزام متزامن',
          },
          {
            key: 'safety',
            label: 'الحماية والسلامة',
            value:
              'مفتاح قفل: يتوقف عند فتح الغطاء، حدّ محور نابضي، زر طوارئ، مفتاح أمان',
          },
          { key: 'weight', label: 'وزن الجهاز', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'أبعاد الجهاز',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'آلة تعليم ليزر عالية الدقة',
      sections: {
        advantages: 'مزايا منتجاتنا',
        aiTitle: 'تحويل تعليم الذكاء الاصطناعي إلى واقع',
        aiSubtitle:
          'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
        carouselTitle: 'وسم ليزري، تخصيص إبداعي',
        specsTitle: 'مواصفات المنتج',
      },
      bannerFeatures: [
        'ضمان سلامة: تحكم بمفتاحين وحماية ليزر',
        'قدرات نقش وقص بدقة عالية وسرعة عالية وثبات عالٍ',
      ],
      advantages: [
        {
          tagTitle: 'سيناريوهات تطبيق متنوعة',
          desc: 'يناسب هذا الجهاز صناعات متعددة، مثل نقش المجوهرات والعناصر المخصصة وتعريف القطع وغيرها. ويلبي احتياجات النقش المخصص لمختلف الاستخدامات من المجوهرات وزجاجات العطور إلى اللافتات الصناعية الصغيرة.',
        },
        {
          tagTitle: 'تطبيقات مبتكرة في مجال التعليم',
          desc: 'يجلب جهاز Mark M20 دقة بمستوى صناعي إلى المجال التعليمي ليصبح «مساعداً شاملاً» للتعليم الابتكاري، وينمّي قدرة الطلاب من مهارات الوسم الأساسية إلى تطوير مشاريع معقدة.',
        },
        {
          tagTitle: 'مدمج وحديث',
          desc: 'تصميم آلة الوسم الليزري Mark M20 مدمج وحديث، يشغل مساحة صغيرة، وضجيجه منخفض، مع نافذة رؤية كبيرة، ويلبي متطلبات المتانة العالية. كما يتوافق مظهره الأنيق مع معايير السلامة، ومناسب للمؤسسات التعليمية وبيئات البيع بالتجزئة العامة.',
        },
        {
          tagTitle: 'إتمام الوسم خلال ثوانٍ',
          desc: 'حتى عند اختيار أصغر الخطوط، يستطيع Mark M20 إتمام وسم دقيق خلال ثوانٍ. تمتزج هذه السرعة الفريدة مع سير العمل المبسّط وكفاءة برنامج تطبيقات الليزر LightMaker لتضمن رفع الإنتاجية بشكل ملحوظ. ',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'نوع الليزر', value: 'ليزر ليفي' },
          { key: 'laserPower', label: 'قدرة الليزر', value: '20W / 30W / 50W' },
          {
            key: 'markArea',
            label: 'منطقة الوسم',
            value:
              'قياسي 110×110mm (يمكن التوسعة بتبديل عدسات مجال مختلفة مثل 175×175mm وغيرها)',
          },
          { key: 'maxHeight', label: 'أقصى ارتفاع عمل', value: '≤130mm' },
          { key: 'connection', label: 'طريقة الاتصال', value: 'Ethernet' },
          {
            key: 'os',
            label: 'أنظمة التشغيل المدعومة',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'نظام التغذية الكهربائية',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'الحماية والسلامة',
            value: 'يتوقف عند فتح الغطاء، حدّ محور نابضي، زر طوارئ، مفتاح أمان',
          },
          { key: 'software', label: 'البرمجيات المدعومة', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'نظام الحركة',
            value: 'رفع/خفض كهربائي لولبي عالي الدقة لرأس الوسم',
          },
          {
            key: 'fileFormat',
            label: 'الملفات المدعومة',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: 'قطر بقعة التركيز', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'آلة قص ونقش ليزر مكتبية ذكية',
      sections: {
        advantages: 'مزايا منتجاتنا',
        aiTitle: 'تحويل تعليم الذكاء الاصطناعي إلى واقع',
        aiSubtitle:
          'تمكين رقمنة التعليم بالذكاء الاصطناعي + التعليم، ودمج مفاهيم مبتكرة',
        carouselTitle: 'قص إبداعي يبدأ من هنا',
        specsTitle: 'مواصفات المنتج',
      },
      bannerFeatures: [
        'سريع / باب خلفي مفتوح / تركيز تلقائي عالي الكفاءة',
        'آلة نقش وقص ليزر متعددة الوظائف',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'منطقة العمل',
          desc: 'نتائج قص ونقش ممتازة مع عدة طرازات وتكوينات متعددة لقدرة الليزر لتلبية احتياجات التطبيقات المختلفة\nنوع الليزر: CO2 تيار مستمر\nقدرة الليزر: 60W-130W\nLight640 (600*400mm)\nLight960 (900*600mm)\nLight1390 (1300*900mm)\nLight1610 (1600*1000mm)',
        },
        {
          tagTitle: 'تركيز تلقائي عالي الكفاءة + تحديد بالنقطة الحمراء',
          desc: 'يتيح التركيز التلقائي تركيزاً وتموضعاً سريعاً ودقيقاً قبل القص والنقش. ومع شعاع تحديد بالنقطة الحمراء يمكن رؤية موضع العمل في الوقت الفعلي، ما يوفر كثيراً من الوقت ويمنح نتائج قص ونقش أفضل.',
        },
        {
          tagTitle: 'تصميم باب خلفي مفتوح',
          desc: 'يسمح تصميم الباب الخلفي المفتوح بوضع مواد قص ونقش بطول غير محدود؛ ألواح بطول 600mm×∞ تجعل العمل أكثر سهولة وبقيود أقل.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'نتائج قص ونقش ممتازة',
            desc: 'مزوّدة بمنصة قص ليزر عالية الدقة، وقد وصلت معالجة مواد مثل الخشب والأكريليك إلى معايير وكفاءة على مستوى الشركات، ما يمكّن الإنتاج الكمي لمنتجات الحِرف بالليزر ويعزز إنتاجية الشركة وقوة العلامة.',
          },
          {
            tagTitle: 'مزوّد بأنبوب ليزر عالي الجودة ومكوّنات دقيقة',
            desc: 'خط منتجات متنوع يتيح اختيار نوع الليزر وشدة المعالجة وفق احتياجات العميل لتلبية متطلبات إنتاج مختلفة، ويوفر تطبيقات أوسع لمواد مثل الخشب والزجاج والأكريليك وغيرها.',
          },
          {
            tagTitle: 'اختبارات جودة صارمة لضمان الجودة',
            desc: 'اختبارات صارمة على خط الإنتاج مع تحكم دقيق في المسار الضوئي وأكثر من 5 اختبارات قص ونقش لضمان أنبوب ليزر CO2 بمخرج ثابت ومتسق. وبفضل ثبات القدرة وبقعة ليزر دقيقة، يمكن تحقيق نقش متجانس وحتى تفاصيل معقدة.',
          },
        ],
        light1390: [
          {
            tagTitle: 'نتائج قص ونقش ممتازة',
            desc: 'مزوّدة بمنصة قص ليزر عالية الدقة، وقد وصلت معالجة مواد مثل الخشب والأكريليك إلى معايير وكفاءة على مستوى الشركات، ما يمكّن الإنتاج الكمي لمنتجات الحِرف بالليزر ويعزز إنتاجية الشركة وقوة العلامة.',
          },
          {
            tagTitle: 'مزوّد بأنبوب ليزر عالي الجودة ومكوّنات دقيقة',
            desc: 'خط منتجات متنوع يتيح اختيار نوع الليزر وشدة المعالجة وفق احتياجات العميل لتلبية متطلبات إنتاج مختلفة، ويوفر تطبيقات أوسع لمواد مثل الخشب والزجاج والأكريليك وغيرها.',
          },
          {
            tagTitle: 'اختبارات جودة صارمة لضمان الجودة',
            desc: 'اختبارات صارمة على خط الإنتاج مع تحكم دقيق في المسار الضوئي وأكثر من 5 اختبارات قص ونقش لضمان أنبوب ليزر CO2 بمخرج ثابت ومتسق. وبفضل ثبات القدرة وبقعة ليزر دقيقة، يمكن تحقيق نقش متجانس وحتى تفاصيل معقدة.',
          },
        ],
        light1610: [
          {
            tagTitle: 'وظائف أمان شاملة ومتقدمة',
            desc: '1. إيقاف طوارئ\n2. ضوء إنذار\n3. مفتاح مقاوم للماء\n4. سلك تأريض\n5. إنذار كاشف حرارة مدمج يعمل تلقائياً عند نشاط غير طبيعي للجهاز\n6. حماية قفل الغطاء\n7. نافذة حماية متينة من زجاج مقوّى',
          },
          {
            tagTitle: 'متين وذو جودة ممتازة',
            desc: '1. مناسب جداً للمشاريع الفردية أو الإنتاج واسع النطاق.\n2. خيارات واسعة لمنطقة العمل من 600 x 400MM إلى 1600 x 1000MM.\n3. سرعة نقش لا مثيل لها.\n4. تصميم خبراء الصناعة.\n5. خيار مثالي للتخصيص والتعليم والتطبيقات الصناعية.',
          },
          {
            tagTitle: 'تحسين الإنتاج عبر المراقبة الذكية',
            desc: 'مصمم لحماية أغلى مكونات الجهاز (المحاور، رأس الليزر، العناصر البصرية، العدسات) من الغبار والأوساخ، لضمان تشغيل موثوق لسنوات حتى مع الاستخدام المكثف.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Light 640، ماذا يمكنه أن يفعل؟',
          items: [
            {
              title: 'Light 640 - مشروع 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - مشروع 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - مشروع 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - مشروع 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - مشروع 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - مشروع 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - مشروع 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - مشروع 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Light 960، ماذا يمكنه أن يفعل؟',
          items: [
            {
              title: 'Light 960 - مشروع 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - مشروع 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - مشروع 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - مشروع 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - مشروع 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - مشروع 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - مشروع 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - مشروع 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Light 1390، ماذا يمكنه أن يفعل؟',
          items: [
            {
              title: 'Light 1390 - مشروع 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - مشروع 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - مشروع 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - مشروع 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - مشروع 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - مشروع 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - مشروع 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - مشروع 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Light 1610، ماذا يمكنه أن يفعل؟',
          items: [
            {
              title: 'Light 1610 - مشروع 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - مشروع 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - مشروع 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - مشروع 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - مشروع 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - مشروع 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - مشروع 6',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - مشروع 6',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'نظام التبريد',

          exhaustTitle: 'نظام العادم',
        },
        left: [
          { key: 'model', label: 'طراز الجهاز', value: 'Light 640' },
          { key: 'workArea', label: 'مساحة العمل', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'نوع الليزر',
            value: 'أنبوب ليزر زجاجي CO₂ محكم الإغلاق',
          },
          {
            key: 'laserPower',
            label: 'قدرة الليزر',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'ارتفاع محور Z',
            value: '135mm（5.3 بوصة）',
          },
          {
            key: 'tableSize',
            label: 'أبعاد طاولة العمل',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: 'أقصى حجم للمواد (الأبواب الأمامية والخلفية مغلقة)',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: 'أقصى حجم للمواد (الباب الخلفي مفتوح)',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: 'أبعاد الجهاز (عرض × طول × ارتفاع)',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: 'وزن الجهاز',
            value: '300kg（660 رطل）',
          },
          {
            key: 'maxSpeed',
            label: 'أقصى سرعة عمل',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'دقة التمركز',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'وضع التركيز',
            value: 'تركيز تلقائي / تركيز يدوي',
          },
          {
            key: 'resume',
            label: 'استئناف النقش بعد انقطاع الكهرباء',
            value: 'مدعوم',
          },
          {
            key: 'transmission',
            label: 'نظام الحركة',
            value: 'محرك خطوي عالي السرعة + محرك حلقة مغلقة عالي الدقة',
          },
          {
            key: 'connection',
            label: 'طرق الاتصال',
            value: 'LAN / USB / WiFi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'البرمجيات',
            value: 'Good-Laser LightMaker (متوافق مع LightBurn)',
          },
          {
            key: 'process',
            label: 'عمليات المعالجة',
            value: 'رسم خطي، قص، نقش عميق، نقش سطحي',
          },
          {
            key: 'fileFormats',
            label: 'تنسيقات الملفات المدعومة',
            value: 'نقطي: JPG / PNG / BMP؛ متجهي: LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'التردد',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'الطور',
            value: 'أحادي الطور',
          },
          {
            key: 'current',
            label: 'تيار الحمل الكامل',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'الجهد',
            value: '230V تيار متردد',
          },
          {
            key: 'totalPower',
            label: 'القدرة الإجمالية',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'المواد المناسبة',
            value:
              'الخشب، الأكريليك، الجلد، الأقمشة، البلاستيك، الكرتون، المطاط، ألواح ثنائية اللون، الرخام، الزجاج، الألمنيوم المؤكسد وغيرها من المواد غير المعدنية',
          },
          {
            key: 'safety',
            label: 'معايير السلامة',
            value:
              'متوافق مع معايير السلامة CE الأوروبية، ويشمل حماية التوقف عند فتح حجرة العمل، ونظام حماية التبريد، ونظام إنذار تلقائي للتحكم بدرجة الحرارة، ونظام حماية من تسرب التيار، ونظام حماية الإيقاف الطارئ، ونظام المسار الضوئي، ونظام مراقبة بزجاج مقوّى، ومؤشر حالة التشغيل وغيرها',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'طريقة التبريد',
            value: 'تبريد مائي',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'قطر فتحة العادم',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'أنبوب ليزر زجاجي CO₂ محكم الإغلاق',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm（5.3 بوصة）',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg（902 رطل）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'تركيز تلقائي / تركيز يدوي',
          resume: 'مدعوم',
          transmission: 'محرك خطوي عالي السرعة + محرك حلقة مغلقة عالي الدقة',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (متوافق مع LightBurn)',
          process: 'رسم خطي، قص، نقش عميق، نقش سطحي',
          fileFormats: 'نقطي: JPG / PNG / BMP؛ متجهي: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'أحادي الطور',
          current: '6A',
          voltage: '230V تيار متردد',
          totalPower: '≤ 1.5kW',
          materials:
            'الخشب، الأكريليك، الجلد، الأقمشة، البلاستيك، الكرتون، المطاط، ألواح ثنائية اللون، الرخام، الزجاج، الألمنيوم المؤكسد وغيرها من المواد غير المعدنية',
          safety:
            'متوافق مع معايير السلامة CE الأوروبية، ويشمل حماية التوقف عند فتح حجرة العمل، ونظام حماية التبريد المائي، ونظام إنذار تلقائي للتحكم بدرجة الحرارة، ونظام حماية من تسرب التيار، ونظام حماية الإيقاف الطارئ، ونظام المسار الضوئي، ونظام مراقبة بزجاج مقوّى، ومؤشر حالة التشغيل وغيرها',
          coolingMode: 'تبريد مائي',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'أنبوب ليزر زجاجي CO₂ محكم الإغلاق',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm（5.3 بوصة）',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg（1100 رطل）',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'تركيز تلقائي / تركيز يدوي',
          resume: 'مدعوم',
          transmission: 'محرك خطوي عالي السرعة + محرك حلقة مغلقة عالي الدقة',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (متوافق مع LightBurn)',
          process: 'رسم خطي، قص، نقش عميق، نقش سطحي',
          fileFormats: 'نقطي: JPG / PNG / BMP؛ متجهي: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'أحادي الطور',
          current: '6A',
          voltage: '230V تيار متردد',
          totalPower: '≤ 1.5kW',
          materials:
            'الخشب، الأكريليك، الجلد، الأقمشة، البلاستيك، الكرتون، المطاط، ألواح ثنائية اللون، الرخام، الزجاج، الألمنيوم المؤكسد وغيرها من المواد غير المعدنية',
          safety:
            'متوافق مع معايير السلامة CE الأوروبية، ويشمل حماية التوقف عند فتح حجرة العمل، ونظام حماية التبريد المائي، ونظام إنذار تلقائي للتحكم بدرجة الحرارة، ونظام حماية من تسرب التيار، ونظام حماية الإيقاف الطارئ، ونظام المسار الضوئي، ونظام مراقبة بزجاج مقوّى، ومؤشر حالة التشغيل وغيرها',
          coolingMode: 'تبريد مائي',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'أنبوب ليزر زجاجي CO₂ محكم الإغلاق',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm（5.3 بوصة）',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg（1298 رطل）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'تركيز تلقائي / تركيز يدوي',
          resume: 'مدعوم',
          transmission: 'محرك خطوي عالي السرعة + محرك حلقة مغلقة عالي الدقة',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (متوافق مع LightBurn)',
          process: 'رسم خطي، قص، نقش عميق، نقش سطحي',
          fileFormats: 'نقطي: JPG / PNG / BMP؛ متجهي: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'أحادي الطور',
          current: '6A',
          voltage: '230V تيار متردد',
          totalPower: '≤ 1.5kW',
          materials:
            'الخشب، الأكريليك، الجلد، الأقمشة، البلاستيك، الكرتون، المطاط، ألواح ثنائية اللون، الرخام، الزجاج، الألمنيوم المؤكسد وغيرها من المواد غير المعدنية',
          safety:
            'متوافق بالكامل مع معايير السلامة CE الأوروبية، ويشمل حماية التوقف عند فتح الغطاء، وحماية التبريد المائي، وإنذار درجة الحرارة، وحماية من تسرب التيار، وإيقافاً طارئاً، ونظام دائرة ليزر مغلق',
          coolingMode: 'تبريد مائي',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'عنوان بريدك الإلكتروني',
      button: 'اشتراك',
    },
    social: {
      tiktok: 'تيك توك',
      weibo: 'قنوات الفيديو',
      wechat: 'ويتشات',
      redbook: 'شياو هونغ شو',
    },
    companyDesc:
      'نركز على تعليم الإبداع التكنولوجي للأطفال من 3 إلى 16 عاماً، وننشئ مساحات تعليم الابتكار العلمي والتقني، ونطور منتجات ودورات تعليم الابتكار ذاتياً، حول تعلم برمجيات التصميم ونقش الليزر والبرمجة وغيرها من المجالات.',
    navColumns: [
      {
        title: 'المنتجات',
        items: [
          { label: 'الأجهزة', to: '/product/light530' },
          { label: 'الحِزم', to: '/product/kits' },
          { label: 'الدورات', to: '/product/courses' },
        ],
      },
      {
        title: 'البرمجيات',
        items: [
          { label: 'منصة Zhongze السحابية', to: '/software/cloud-platform' },
          { label: 'منصة Zhongze للتعلم', to: '/software/learning-platform' },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'خدمات التعليم',
        items: [
          { label: 'حلول تعليم الذكاء الاصطناعي', to: '/edu-services' },
          { label: 'تعليم الصُنّاع - K12', to: '/edu-services/maker-k12' },
          {
            label: 'نماذج معمارية - التعليم المهني',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'تصميم ثقافي وإبداعي - التعليم المهني العالي',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'الفنون والحِرف - الجامعة',
            to: '/edu-services/arts-university',
          },
          { label: 'مساحة الابتكار', to: '/edu-services' },
        ],
      },
      {
        title: 'الخدمة والدعم',
        items: [
          { label: 'مركز التنزيلات', to: '/support/download' },
          { label: 'خدمة ما بعد البيع', to: '/support/after-sales' },
        ],
      },
      {
        title: 'التعاون التعليمي',
        items: [{ label: 'التعاون التعليمي', to: '/edu-services/cooperation' }],
      },
      {
        title: 'من نحن',
        items: [
          { label: 'من نحن', to: '/about' },
          { label: 'الأخبار', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'خط المبيعات: 18379276683',
      email: 'البريد الإلكتروني: sam@zz-steam.com',
      address:
        'العنوان: شنتشن، فوتيان، طريق باغوا الرابع، مبنى هواشينغدا، البرج A',
    },
    qrDesc: 'اعرف المزيد',
  },

  globalContactForm: {
    title: 'اتصل بنا',
    subtitle: 'يرجى تعبئة النموذج التالي وسنتواصل معك قريباً',
    fields: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      company: 'الشركة',
      message: 'الرسالة',
    },
    placeholders: {
      name: 'يرجى إدخال اسمك',
      email: 'يرجى إدخال بريدك الإلكتروني',
      phone: 'يرجى إدخال رقم هاتفك',
      company: 'يرجى إدخال اسم شركتك',
      message: 'يرجى إدخال نص رسالتك',
    },
    submitting: 'جارٍ الإرسال...',
    submit: 'إرسال',
    visual: {
      title: 'نتطلع إلى التعاون معك',
      description:
        'نقدم خدمة ودعماً احترافيين. إذا كانت لديك أي أسئلة، فلا تتردد في التواصل معنا.',
    },
    contact: {
      phone: 'هاتف التواصل',
      email: 'بريد التواصل',
    },
    validation: {
      name: 'يرجى إدخال الاسم',
      email: 'يرجى إدخال البريد الإلكتروني',
      emailFormat: 'يرجى إدخال بريد إلكتروني بصيغة صحيحة',
      phone: 'يرجى إدخال رقم الهاتف',
      phoneFormat: 'يرجى إدخال رقم هاتف صالح',
      message: 'يرجى إدخال نص الرسالة',
    },
    success: 'تم الإرسال بنجاح! سنتواصل معك قريباً.',
    networkError: 'فشل الإرسال، يرجى المحاولة لاحقاً.',
  },
};
